import initializeAttachment from './initialization/initializeAttachment';
import AttachmentModel from '../store/schema/AttachmentModel';
import AttachmentStore from '../store/schema/AttachmentStore';
import getStore from '../store/store';
import createAttachmentModel from '../utils/createAttachmentModel';
import { action } from 'satcheljs/lib/legacy';
import AttachmentInitializationParameters, {
    AttachmentModelPropertyValues,
} from '../store/schema/AttachmentInitializationParameters';

function setInitialValuesForModel(
    attachment: AttachmentModel,
    initialValue: AttachmentModelPropertyValues
) {
    initialValue = initialValue ? initialValue : {};

    Object.keys(initialValue).forEach(propertyName => {
        if (initialValue[propertyName]) {
            attachment[propertyName] = initialValue[propertyName];
        }
    });
}

export default action('addAndInitializeAttachments')(function addAndInitializeAttachments(
    coreAttachments: AttachmentInitializationParameters[],
    isReadOnly: boolean,
    forceAdd: boolean = false,
    skipInitialization: boolean = false
): void {
    const store: AttachmentStore = getStore();

    if (!forceAdd) {
        // Filter out all the attachments we already have in the store as we don't want to recreate them
        coreAttachments = coreAttachments.filter(
            attachmentWrapper =>
                !store.attachments.has(attachmentWrapper.attachment.AttachmentId.Id)
        );
    }

    // Create the models and initialize them
    const models: AttachmentModel[] = coreAttachments.map(
        (attachmentWrapper: AttachmentInitializationParameters) => {
            const {
                attachmentId,
                attachment,
                permissionInfo,
                modelInitializationValues,
            } = attachmentWrapper;
            const model: AttachmentModel = createAttachmentModel(attachmentId, attachment);
            if (!skipInitialization) {
                initializeAttachment(model, permissionInfo, isReadOnly);
            }

            setInitialValuesForModel(model, modelInitializationValues || {});
            return model;
        }
    );

    // Adding all the attachments in the store
    models.forEach(model => {
        store.attachments.set(model.id.Id, model);
    });
});
